export default {
  title: {
    en: 'Do you want an extra life?'
  },

  description: {
    en: (price: number) =>
      `Buy an extra life for ${price} My McDonald's bonus points.`
  },

  balance: {
    en: 'Your balance:'
  },

  submit: {
    en: 'Buy extra life'
  },

  cancel: {
    en: "No, I'll quit"
  }
};
